const DECIMAL_BASE = 10;

// Money arrives in the currency's minor unit (`_cents`): pesos for CLP,
// cents for USD. Intl knows how many fraction digits each currency has.
export function formatMoney(cents: number | null | undefined, currency = 'CLP'): string {
  if (cents === null || cents === undefined) return '—';
  const formatter = new Intl.NumberFormat('es-CL', { style: 'currency', currency });
  const digits = formatter.resolvedOptions().maximumFractionDigits ?? 0;

  return formatter.format(cents / (DECIMAL_BASE ** digits));
}

export function formatQuantity(quantity: number | null | undefined): string {
  if (quantity === null || quantity === undefined) return '—';

  return new Intl.NumberFormat('es-CL', { maximumFractionDigits: 3 }).format(quantity);
}

// A stable color per category so the same category reads the same in every table.
const CATEGORY_COLORS = ['primary', 'teal', 'deep-purple', 'orange', 'pink', 'indigo', 'brown', 'cyan'] as const;

export function categoryColor(categoryId: number): string {
  return CATEGORY_COLORS[Math.abs(categoryId) % CATEGORY_COLORS.length];
}

export const UNITS_OF_MEASURE = [
  { value: 'unit', title: 'Unidad' },
  { value: 'pair', title: 'Par' },
  { value: 'tablet', title: 'Comprimido' },
  { value: 'capsule', title: 'Cápsula' },
  { value: 'ml', title: 'Mililitro' },
  { value: 'g', title: 'Gramo' },
  { value: 'sachet', title: 'Sobre' },
  { value: 'ampoule', title: 'Ampolla' },
  { value: 'vial', title: 'Frasco ampolla' },
  { value: 'syringe', title: 'Jeringa' },
  { value: 'patch', title: 'Parche' },
  { value: 'suppository', title: 'Supositorio' },
  { value: 'enema', title: 'Enema' },
] as const;

export const CONDITIONS = [
  { value: 'operational', title: 'Operativo', color: 'success' },
  { value: 'needs_attention', title: 'Con observaciones', color: 'warning' },
  { value: 'out_of_service', title: 'Fuera de servicio', color: 'error' },
] as const;

export const EXIT_CAUSES = [
  { value: 'damaged', title: 'Daño o rotura' },
  { value: 'lost', title: 'Extravío' },
  { value: 'stolen', title: 'Robo' },
  { value: 'expired', title: 'Vencimiento' },
  { value: 'other', title: 'Otra' },
] as const;
